import { get, toString } from 'lodash';

import { RecentSearch } from '~/features/advanced-search/types';
import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

import { SearchableFieldId } from './alert';

interface PinnedFiltersResponse {
  pinnedFilters?: {
    value?: Array<SearchableFieldId | PilotId>;
  };
}

interface PinnedFiltersReturnValue {
  data?: Array<SearchableFieldId>;
}

interface PinnedFiltersParams {
  context: string;
  pinnedFilters: Array<SearchableFieldId>;
}

interface RecentSearchesResponse {
  recentSearches?: {
    value?: Array<RecentSearch>;
  };
}

export type ContextType =
  | 'FOLDER'
  | 'SEARCH'
  | 'GROUP'
  | 'EVISEARCH_SEARCH'
  | 'GLOBAL';

export const getPinnedFilters = async (
  context: ContextType,
): Promise<PinnedFiltersReturnValue> => {
  const response: PinnedFiltersResponse = await pilot.get(
    '/user/preferences/',
    { params: { context } },
  );
  return { data: response?.pinnedFilters?.value?.map(toString) };
};

export const updatePinnedFilters = ({
  context,
  pinnedFilters,
}: PinnedFiltersParams): Promise<{}> => {
  return pilot.put(
    '/user/preferences/',
    { value: pinnedFilters },
    { params: { context, key: 'pinnedFilters' } },
  );
};

export const getRecentSearches = async ({
  context,
}: {
  context: ContextType;
}) => {
  const response: RecentSearchesResponse = await pilot.get(
    '/user/preferences/',
    {
      params: { context, key: 'recentSearches' },
    },
  );
  return { data: response?.recentSearches?.value };
};

export const updateRecentSearches = ({
  context,
  recentSearches,
}: {
  context: ContextType;
  recentSearches: RecentSearch[];
}): Promise<{}> => {
  return pilot.put(
    '/user/preferences/',
    { value: recentSearches },
    { params: { context, key: 'recentSearches' } },
  );
};

export const getLocalizationPreferences = async () => {
  const response = await pilot.get('/user/preferences/', {
    params: { key: 'i18n', context: 'GLOBAL' },
  });

  return { data: get(response, 'i18n.value', {}) };
};

export const updateLocalizationPreferences = async ({
  language,
  locale,
}: {
  language?: string;
  locale?: string;
}) => {
  await pilot.put(
    '/user/preferences/',
    { value: { language, locale } },
    { params: { key: 'i18n', context: 'GLOBAL' } },
  );
};
